import service from "@/utils/request";
//学员列表
export interface teacherListData {
  page: number;
  page_size: number;
  key_word?: string;
  on_job?: number;
}
export interface rollCallListData {
  page: number;
  page_size: number;
  roll_call_id?: number;
  class_id?: number;
  teacher_id?: number;
  course_id?: number;
  staff_id?: number;
  roll_call_start_date?: string;
  roll_call_end_date?: string;
  lesson_start_date?: string;
  lesson_end_date?: string;
  status?: number;
}
//老师列表
export const teacherList = (params: teacherListData) => {
  return service({
    url: "/api/v1/teacher/list",
    method: "get",
    params,
  });
};
//序号管理
export const modifysort = (data: { staff_id: number; sort: number }) => {
  return service({
    url: "/api/v1/teacher/modify/sort",
    method: "post",
    data,
  });
};
//教师详情
export const teacherdetail = (params: { staff_id: number }) => {
  return service({
    url: "/api/v1/teacher/detail",
    method: "get",
    params,
  });
};
//授课班级
export const classlist = (params: {
  page: number;
  page_size: number;
  staff_id: number;
}) => {
  return service({
    url: "/api/v1/teacher/class/list",
    method: "get",
    params,
  });
};
//点名记录列表
export const rollCallList = (params: rollCallListData) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/list",
    method: "get",
    params,
  });
};
//老师编辑
export const modifyDetail = (data: { staff_id: number; detail: string }) => {
  return service({
    url: "/api/v1/staff/modify/detail",
    method: "post",
    data,
  });
};

export interface relationStudentListInter {
  page: number;
  page_size: number;
  teacher_id: number;
  student_status?: number;
  grant_lesson_status?: number;
  roll_call_start_time?: string;
  roll_call_end_time?: string;
  admission_start_time?: string;
  admission_end_time?: string;
  student_key_word?: string;
  sort_field?: string;
  sort_type?: string;
  course_id?: number;
  stop_status?: number[];
}
//教师关联学生列表
export const relationStudentListApi = (data: relationStudentListInter) => {
  return service({
    url: "/api/v1/teacher/relation_student/list",
    method: "post",
    data,
  });
};
// 教师关联学生相关统计
export const relationStudentStatisticsApi = (params: {
  teacher_id: number;
}) => {
  return service({
    url: "/api/v1/teacher/relation_student/statistics",
    method: "get",
    params,
  });
};
// 教师关联学生详情
export const relationStudentDetailApi = (params: { relation_id: number }) => {
  return service({
    url: "/api/v1/teacher/relation_student/detail",
    method: "get",
    params,
  });
};
// 学生关联教师详情（1vN）
export const studentCourseLogListApi = (params: {
  student_id: number;
  course_id: number;
}) => {
  return service({
    url: "/api/v1/teacher/relation_student/student_course/log_list",
    method: "get",
    params,
  });
};
// 教师关联学生列表统计
export const relationStudentListStatisticsApi = (data: {
  teacher_id: number;
}) => {
  return service({
    url: "/api/v1/teacher/relation_student/list_statistics",
    method: "post",
    data,
  });
};
// 学生列表
export interface teacherRelationStudentListInter {
  teacher_id: number;
  student_id: number;
  page: number;
  page_size: number;
  key_word?: string;
}
export const teacherRelationStudentListApi = (
  params: teacherRelationStudentListInter
) => {
  return service({
    url: "/api/v1/teacher/relation_student/student_list",
    method: "get",
    params,
  });
};
// 手动关联
export interface RelationStudentRelationInter {
  teacher_id: number;
  student_id: number;
  remark: string;
  course_ids: number[];
}
export const relationStudentRelationApi = (
  data: RelationStudentRelationInter
) => {
  return service({
    url: "/api/v1/teacher/relation_student/relation",
    method: "post",
    data,
  });
};

// 手动解除关联
export const RelationStudentReleaseApi = (data: {
  relation_id: number;
  remark: string;
}) => {
  return service({
    url: "/api/v1/teacher/relation_student/release",
    method: "post",
    data,
  });
};
